import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledList } from '../Menu/List.styled';
import { SelectListItem } from './SelectListItem';
import { StyledSelectMenu } from './SelectMenu.styled';
export function SelectMenu(selectMenuProps) {
  var items = selectMenuProps.items,
    width = selectMenuProps.width;
  return /*#__PURE__*/React.createElement(StyledSelectMenu, {
    style: {
      width: width
    }
  }, /*#__PURE__*/React.createElement(StyledList, null, items.map(function (item, i) {
    return !!item && /*#__PURE__*/React.createElement(SelectListItem, _extends({
      key: i
    }, item));
  })));
}